import axios from 'axios';

export const FETCH_CURRENT_PAGE = 'FETCH_CURRENT_PAGE';
export const CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE';
export const EMPTY_CURRENT_PAGE = 'EMPTY_CURRENT_PAGE';
export const NAVBAR_SET_BUTTON = 'NAVBAR_SET_BUTTON';
export const REGENERATOR = 'REGENERATOR';

export const change = (key, data = null, forceUpdate = false) => async (dispatch, getState) => {
  const actualCurrentPage = getState().currentPage[key];
  const currentPage = actualCurrentPage && !forceUpdate ? { ...actualCurrentPage, ...data } : data;
  dispatch({ type: CHANGE_CURRENT_PAGE, payload: { key, currentPage } });
};

export const fetch = (url, req = null) => async (dispatch, getState) => {
  try {
    const response = await axios.post(`${getState().global.urlData.userApiUrl}${url}`, req);
    const res = await response.data;
    if (!res.error) dispatch({ type: FETCH_CURRENT_PAGE, payload: res });
  } catch (err) {
    throw new Error(err.response.data.message);
  }
};

export const toggleWidgetStatic = (req) => (dispatch) => {
  dispatch({ type: NAVBAR_SET_BUTTON, payload: req });
};

export const regenerator = (req) => (dispatch) => {
  dispatch({ type: REGENERATOR, payload: req });
};
export const empty = () => async (dispatch) => {
  dispatch({ type: EMPTY_CURRENT_PAGE });
};
